export const products = [
    {
        id: 1,
        category: "Sporting Goods",
        name: "Football Nike",
        price: "€35.25",
        image: require(`./../Images/Football.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 6
    },
    {
        id: 2,
        category: "Sporting Goods",
        name: "Basketball Molten",
        price: "€31.35",
        image: require(`./../Images/Basketball.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 8
    },
    {
        id: 3,
        category: "Sporting Goods",
        name: "Baseball Rawlings Official",
        price: "€25.65",
        image: require(`./../Images/Baseball.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 10
    },
    {
        id: 4,
        category: "Electronics",
        name: "iPod Touch",
        price: "€99.99",
        image: require(`./../Images/iPod Touch.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 5
    },
    {
        id: 5,
        category: "Electronics",
        name: "iPhone 8",
        price: "€399.99",
        image: require(`./../Images/iPhone 8.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 0
    },
    {
        id: 6,
        category: "Electronics",
        name: "Nexus 9",
        price: "€299.99",
        image: require(`./../Images/Nexus 9.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 4
    },
    {
        id: 7,
        category: "Furniture",
        name: "Home computer desk",
        price: "€55.99",
        image: require(`./../Images/Home Computer Desk.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 3
    },
    {
        id: 8,
        category: "Furniture",
        name: "Office desk",
        price: "€87.59",
        image: require(`./../Images/Office Desk.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 2
    },
    {
        id: 9,
        category: "Furniture",
        name: "Office metal chair",
        price: "€27.99",
        image: require(`./../Images/Office Metal Chair.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 0
    },
    {
        id: 10,
        category: "Flowers",
        name: "Rose",
        price: "€0.99",
        image: require(`./../Images/Rose.jpg`),
        details: 'Home flowers etc...',
        stock: 55
    },
    {
        id: 11,
        category: "Flowers",
        name: "Tulip",
        price: "€1.29",
        image: require(`./../Images/Tulip.jpg`),
        details: 'Home flowers etc...',
        stock: 47
    },
    {
        id: 12,
        category: "Flowers",
        name: "Carnation",
        price: "€0.75",
        image: require(`./../Images/Carnation.jpg`),
        details: 'Home flowers etc...',
        stock: 0
    },
    {
        id: 13,
        category: "Electronics",
        name: "Samsung A10",
        price: "€179.99",
        image: require(`./../Images/Samsung a10.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 8
    },
    {
        id: 14,
        category: "Sporting Goods",
        name: "Tennis racquet Wilson",
        price: "€85.89",
        image: require(`./../Images/Tennis Racquet.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 0
    },
    {
        id: 15,
        category: "Furniture",
        name: "Kitchen chair",
        price: "€81.99",
        image: require(`./../Images/Kitchen Chair.jpg`),
        details: {
            model_name: 'Some model name...',
            dimensions: 'Some dimensions...',
            material: 'Some material...',
            technical_details: 'Some technical details...',
            color: 'Some color'
        },
        stock: 12
    },
    {
        id: 16,
        category: "Flowers",
        name: "Orchid",
        price: "€9.99",
        image: require(`./../Images/Orchid.jpg`),
        details: 'Home flowers etc...',
        stock: 31
    }
]